export const LOGO_URL = "/logo-amac.png";
